import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ICellRenderer, ICellRendererParams } from '@medpacesoftwaredevelopment/designsystem/lib/components/ag-grid';
import { AgFrameworkComponent } from 'ag-grid-angular';

@Component({
    selector: '',
    standalone: true,
    imports: [],
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class BaseCellRendererComponent<TData, TValue, TContext, TCustomParams extends Object>
    implements AgFrameworkComponent<ICellRendererParams<TData, TValue, TContext>>, ICellRenderer
{
    abstract refresh(params: ICellRendererParams<TData, TValue, TContext> & TCustomParams): boolean;
    public baseParams = signal<ICellRendererParams<TData, TValue, TContext> | null>(null);
    public customParams = signal<TCustomParams | null>(null);
    agInit(params: ICellRendererParams<TData, TValue, TContext> & TCustomParams): void {
        this.baseParams.set(params);
        this.customParams.set(params);
    }
}
